import { supabase } from '../lib/supabase';

export const organizationService = {
  // Create a new organization
  async createOrganization(organizationData) {
    try {
      const { data, error } = await supabase?.from('organizations')?.insert([organizationData])?.select()?.single();

      if (error) throw error;

      // Create financial account for nonprofits
      if (organizationData?.is_501c3) {
        await this.createFinancialAccount(data?.id, `${organizationData?.name} Donation Fund`);
      }

      return { data, error: null };
    } catch (error) {
      return { data: null, error };
    }
  },

  // Get user's organizations
  async getUserOrganizations(userId) {
    try {
      const { data, error } = await supabase?.from('organizations')?.select(`
          *,
          fundraisers(count),
          esg_reports(count),
          financial_accounts(count)
        `)?.eq('owner_id', userId)?.order('created_at', { ascending: false });

      if (error) throw error;
      return { data, error: null };
    } catch (error) {
      return { data: null, error };
    }
  },

  // Get organization by ID (public or owned)
  async getOrganization(organizationId) {
    try {
      const { data, error } = await supabase?.from('organizations')?.select(`
          *,
          fundraisers!inner(
            id, title, description, goal_amount, current_amount, 
            currency, status, start_date, end_date, image_url, is_tax_deductible
          ),
          esg_reports!inner(
            id, title, description, category, metric_type, baseline_value,
            current_value, target_value, measurement_unit, reporting_period_start,
            reporting_period_end, is_public
          )
        `)?.eq('id', organizationId)?.single();

      if (error) throw error;
      return { data, error: null };
    } catch (error) {
      return { data: null, error };
    }
  },

  // Update organization
  async updateOrganization(organizationId, updates) {
    try {
      const { data, error } = await supabase?.from('organizations')?.update(updates)?.eq('id', organizationId)?.select()?.single();

      if (error) throw error;
      return { data, error: null };
    } catch (error) {
      return { data: null, error };
    }
  },

  // Create financial account for organization
  async createFinancialAccount(organizationId, accountName) {
    try {
      const { data, error } = await supabase?.from('financial_accounts')?.insert([{
          organization_id: organizationId,
          account_name: accountName,
          account_type: 'donation_account',
          balance: 0
        }])?.select()?.single();

      if (error) throw error;
      return { data, error: null };
    } catch (error) {
      return { data: null, error };
    }
  },

  // Get organizations for public browsing (verified nonprofits)
  async getPublicOrganizations(filters = {}) {
    try {
      let query = supabase?.from('organizations')?.select(`
          *,
          fundraisers!inner(count),
          esg_reports!inner(count)
        `)?.eq('is_501c3', true)?.not('verified_at', 'is', null);

      if (filters?.industry) {
        query = query?.eq('industry', filters?.industry);
      }

      if (filters?.organization_size) {
        query = query?.eq('organization_size', filters?.organization_size);
      }

      const { data, error } = await query?.order('verified_at', { ascending: false })?.limit(20);

      if (error) throw error;
      return { data, error: null };
    } catch (error) {
      return { data: null, error };
    }
  }
};